﻿export class ApiError extends Error {
    public status: number;
    
    constructor(status: number) {
        super(`API response contains non-ok status code: ${status}`);
        this.status = status;
    }
}

